import { render, staticRenderFns } from "./sendingScript.vue?vue&type=template&id=fed9adba&"
import script from "./sendingScript.vue?vue&type=script&lang=js&"
export * from "./sendingScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports